import { FC, ReactNode } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useFeature } from '../hooks/useFeature';
import permissionImg from '../assets/permission.png';

type TPackageProtectedRouteProps = {
  children: ReactNode;
  permissionKey: string
};

const PackageProtectedRoute: FC<TPackageProtectedRouteProps> = ({ children, permissionKey }) => {
  const { allowRouteAccess } = useFeature();
  const { t } = useTranslation('common');

  if (allowRouteAccess(permissionKey)) {
    return children;
  }

  return (
    <Container sx={{
      pt: 3,
    }}
    >
      <Box sx={{ maxWidth: 480, margin: 'auto' }} />
      <Typography textAlign="center" variant="h3">
        {t('permissionDenied')}
      </Typography>
      <Typography textAlign="center" sx={{ color: 'text.secondary' }}>
        {t('permissionDeniedText')}
      </Typography>
      <Box display="flex" justifyContent="center">
        <img src={permissionImg} height={400} alt="error" />
      </Box>
    </Container>
  );
};

export { PackageProtectedRoute };
